"use client";

import PillButton from "@/app/shared/PillButton";
import AdDetailModel from "@/models/AdDetailModel";
import { Box } from "@mui/material";
import AdBreadcrumbs from "./AdBreadcrumbs";
import { AdActions } from "@/app/shared/ad/AdActions";
import PhoneIcon from "@mui/icons-material/Phone";
import EmailIcon from "@mui/icons-material/Email";

export default function AdNav({
  ad,
  onContactSellerClicked,
}: {
  ad: AdDetailModel;
  onContactSellerClicked: () => void;
}) {
  return (
    <Box
      sx={{
        display: "flex",
        flexWrap: "wrap",
        gap: 2,
        alignItems: "center",
        a: {
          color: "grey.600",
          textDecoration: "none",
        },
      }}
    >
      <AdBreadcrumbs ad={ad} />
      <Box
        sx={{
          display: "flex",
          gap: 2,
          alignItems: "center",
          marginLeft: "auto",
        }}
      >
        <AdActions ad={ad} compactOnMobile />
        {/* AJB: should put message & call here?  at least get it working */}

        {!ad.isInactive && (
          <PillButton
            startIcon={
              <Box
                sx={{
                  display: "flex",
                  gap: 1,
                }}
              >
                <PhoneIcon />
                <EmailIcon />
              </Box>
            }
            onClick={onContactSellerClicked}
            primary
            compactOnMobile
          >
            Contact
          </PillButton>
        )}
      </Box>
    </Box>
  );
}
